module.exports = __webpack_public_path__ + "img/05597965000127.fbbd95a5.png";